module.exports = __webpack_public_path__ + "static/media/double-sea-2-2.33aed0d8.jpg";